module.exports = __webpack_public_path__ + "img/monitoring-alt.d5b2e8d2.svg";